var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSensitiveInfo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4321_169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.666 4.72461C12.4695 4.72473 13.2403 5.04419 13.8086 5.6123C14.377 6.18069 14.6963 6.95204 14.6963 7.75586V8.63477H15.25C15.6642 8.63477 16 8.97055 16 9.38477V15.25C15.9997 15.664 15.664 16 15.25 16H8.08203C7.66808 15.9999 7.33231 15.6639 7.33203 15.25V9.38477C7.33203 8.97061 7.6679 8.63487 8.08203 8.63477H8.63477V7.75586C8.63477 6.95215 8.95421 6.18067 9.52246 5.6123C10.0907 5.04402 10.8624 4.72473 11.666 4.72461ZM8.83203 14.5H14.5V10.1348H8.83203V14.5ZM11.666 6.22461C11.2602 6.22473 10.87 6.38588 10.583 6.67285C10.2961 6.95991 10.1348 7.34997 10.1348 7.75586V8.63477H13.1963V7.75586C13.1963 7.34987 13.0351 6.95993 12.748 6.67285C12.4611 6.38605 12.0717 6.22473 11.666 6.22461Z",
    fill: "#676879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77284 15.3391H1.71699C1.63562 15.3391 1.56908 15.2742 1.56703 15.1929L1.29939 4.57854C1.29841 4.53932 1.31282 4.50128 1.33956 4.47256L4.74433 0.815147C4.77134 0.786129 4.80874 0.768986 4.84836 0.767464L5.94655 0.725273L8.2931 0.725273L12.1085 0.725273C12.1913 0.725273 12.2585 0.79243 12.2585 0.875273V3.16536",
    stroke: "#676879",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4321_169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensitiveInfo);
export default __webpack_public_path__ + "static/media/sensitive-info.a82b39e5.svg";
export { ForwardRef as ReactComponent };